import { OrdersService } from '@services/orders.service';
import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';

import { AppConfigService } from '@services/app-config.service';
import { UiService } from '@services/ui.service';
import { AuthService } from '@services/auth.service';
import { PaginationRequest } from '@classes/pagination/pagination-request';
import { environment } from '@environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { NotificationsService } from '@services/notifications.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();

  isAuth: boolean;
  isMaintenance: boolean;
  isError: boolean;
  isRouteLoading: boolean;
  isTranslationLoading: boolean;

  navMode = "side";
  mobileQuery: MediaQueryList;

  private mobileQueryListener: () => void;

  constructor(
    private configSrv: AppConfigService,
    private uiSrv: UiService,
    private authSrv: AuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private media: MediaMatcher,
    private ordersSrv: OrdersService,
    private httpClient: HttpClient,
    private titleSrv: Title,
    private notificationsSrv: NotificationsService
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 999px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    this.isMaintenance = configSrv.isMaintenance;
  }

  ngOnInit() {
    this.clearCacheIfNewVersion();
    this.isAuth = this.authSrv.isAuth();

    this.titleSrv.setTitle(environment.appName);

    this.initSubscriptions();
    this.initNotifications();
  }

  private clearCacheIfNewVersion(): void {
    const newBuild = `${environment.version}.${environment.build}`;
    const oldBuild = localStorage.getItem('build');
    if (newBuild !== oldBuild) {
      localStorage.clear();
      localStorage.setItem('build', newBuild);

      const headers = new HttpHeaders()
        .set('Cache-Control', 'no-cache')
        .set('Pragma', 'no-cache');

      this.httpClient
        .get("", { headers, responseType: "text" })
        .subscribe(() => location.reload());
    }
  }

  toggleSidenav(sidenav: MatSidenav, isToggle?: boolean): void {
    if (isToggle) {
      sidenav.toggle();
    } else if (this.mobileQuery.matches) {
      sidenav.close();
    }
  }

  private initSubscriptions(): void {
    this.subscription.add(
      this.uiSrv.routeLoadingStateChanged
        .subscribe(loadingState => {
          this.isRouteLoading = loadingState;
        })
    );

    this.subscription.add(
      this.uiSrv.translationLoadingStateChanged
        .subscribe(loadingState => {
          this.isTranslationLoading = loadingState;
        })
    );

    this.subscription.add(
      this.authSrv.authChanged
        .subscribe(authStatus => {
          if (this.isAuth !== authStatus) {
            this.isAuth = authStatus;
            this.initNotifications();
          }
        })
    );

    // this.subscription.add(
    //   this.ordersSrv.getCounter()
    //     .subscribe(authStatus => {
    //       if (this.isAuth !== authStatus) {
    //         this.isAuth = authStatus;
    //         this.initNotifications();
    //       }
    //     })
    // );
  }

  private initNotifications(): void {
    if (this.isAuth) {
      this.notificationsSrv.init();
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this.mobileQueryListener);
    this.subscription.unsubscribe();
  }
}
